import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AudioRecorderChatEC } from '../audio-recorder';
import { Asr, AsrChat, ECAsrChat } from '../asr';
import { Translation, TranslationChat } from '../translation';
import ECChatReply from '../ec-chat-page/ECChatReply';

const CardChatEC = () => {
    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorderChatEC />
                            <ECAsrChat />
                            <ECChatReply />            
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default CardChatEC;
